import React, { useState, useEffect } from "react";
import Axios from "axios";
import { baseUrl } from "../../config";
import { Descriptions, Button } from "antd";
import { Redirect } from "react-router-dom";

function App(props) {
  const [response, setResponse] = useState();
  const [deleted, setDeleted] = useState(false);
  const deleteAction = () => {
    Axios.delete(baseUrl + "products/" + props.match.params.id)
      .then((response) => {
        setDeleted(true);
      })
      .catch(function (error) {});
  };
  useEffect(() => {
    Axios.get(baseUrl + "products/" + props.match.params.id)
      .then((response) => {
        setResponse(response.data);
      })
      .catch(function (error) {});
  }, []);
  if (deleted) {
    return <Redirect to="/allproducts/list" />;
  }
  if (!response) {
    return <div>Loading</div>;
  }
  return (
    <div style={{ padding: "100px 0" }}>
      <Descriptions title="Ürün Bilgileri" bordered layout="vertical">
        <Descriptions.Item label="Ürün Name">
          <p style={{ fontSize: "20pt" }}>{response.name}</p>
        </Descriptions.Item>
        <Descriptions.Item label="Ürün ID" span={1}>
          {response._id}
        </Descriptions.Item>
        <Descriptions.Item style={{ fontSize: "30px" }} label="Price">
          <p style={{ fontSize: "30px" }}> {response.price}</p>
        </Descriptions.Item>
        <Descriptions.Item label="Ana Resim" span={3}>
          <img
            alt={"banner"}
            style={{ width: "40%", margin: "0 auto", justifySelf: "center" }}
            src={response.bannerImage}
          ></img>
        </Descriptions.Item>
        <Descriptions.Item label="Resim 2" span={1}>
          <img
            alt={"banner"}
            style={{ width: "40%", margin: "0 auto", justifySelf: "center" }}
            src={response.image1}
          ></img>
        </Descriptions.Item>
        <Descriptions.Item label="Resim 3" span={1}>
          <img
            alt={"banner"}
            style={{ width: "40%", margin: "0 auto", justifySelf: "center" }}
            src={response.image2}
          ></img>
        </Descriptions.Item>
        <Descriptions.Item label="Resim 4" span={1}>
          <img
            alt={"banner"}
            style={{ width: "40%", margin: "0 auto", justifySelf: "center" }}
            src={response.image3}
          ></img>
        </Descriptions.Item>
      </Descriptions>
      <div style={{ paddingTop: 50 }}>
        <Button type="danger" onClick={() => deleteAction()}>
          Delete Product
        </Button>
      </div>
    </div>
  );
}

export default App;
